import { useEffect } from 'react';
import gsap from 'gsap';

export default function ThankYou() {
  useEffect(() => {
    const tl_logo = gsap.timeline();
    tl_logo
      .to("#Thanks_mainComp, #Thanks_mainLogo_G", { opacity: 1, duration: 0.1 })
      .from("#Thanks_mainLogo_G", { scale: 0, duration: 1.2, ease: "power1.inOut" })
      .from("#Thanks_mainLogo", { x: "159px", duration: 1.2, ease: "power1.inOut" }, "-=0.8")
      .from("#Thanks_logo2", { x: "-100%", duration: 1.2, ease: "power1.inOut" }, "<")
      .from(".thank_you", { scale: "0", duration: 1.2, ease: "elastic.out(1, 0.5)"}, "-=0.5")
      .from(".thank_copy", { opacity:0, y:10, duration: 1.0, ease: "power1.inOut"}, "-=1.1")
      .from(".thank_sticker", { opacity:0, duration: 1.0, ease: "power1.inOut"}, "-=1.1");
  }, []);


  return (
    <div className="min-h-screen flex flex-col items-center justify-center p-4">
      <div id="Thanks_mainComp" className="relative flex justify-center mt-8 mb-8">
        <div id="Thanks_mainLogo_G" className="relative flex justify-center">
          <div id="Thanks_mainLogo" className="relative flex justify-center gap-4">
            <div className="flex-shrink-0">
              <img src="/imgs/logo1.png" alt="Live Your Best Lip!" className="w-[87px] h-auto" id="Thanks_logo1" />
            </div>
            <div className="flex-shrink-0 flex items-center overflow-hidden">
              <img src="/imgs/logo2.png" alt="Live Your Best Lip!" className="w-[121px] h-auto" id="Thanks_logo2" />
            </div>
          </div>
        </div>
      </div>

      <div className="w-full max-w-md p-8 space-y-6 text-center ">
        <h1 className="text-6xl font-bold text-white font-Metric thank_you">Thank You! 🎉</h1>
        <div className="space-y-4">
          <p className="text-lg text-white thank_copy">
            Your tip has been submitted successfully!
          </p>
          <p className="thank_sticker text-2xl font-bold text-vaseline-pink">
            Please show this screen to grab your free stickers! ✨
          </p>
        </div>
      </div>
    </div>
  );
}
